import React from "react"
import { get } from 'lodash'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

type TextInputProps = {
  label: string;
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: () => void;
  required?: boolean;
  type?: string;
  form?: any;
}

export default function TextInput({ onChange, label, form, name, type, value }: TextInputProps) {
  const id = name
  const fieldError = get(form, `errors[${name}]`)
  const fieldTouched = get(form, `touched[${name}]`)
  const hasError = fieldTouched && !!fieldError
  const helperText = hasError ? fieldError : " "

  return (
    <Form.Group as={Col} className="mb-3" controlId={id}>
        <Form.Label>{label}</Form.Label>
        <Form.Control type={type} value={value} onChange={onChange} />
        {hasError && (
          <Form.Text id={`${id}--error`} className="text-danger">{helperText}</Form.Text>
        )}
    </Form.Group>
  )
}
